.wrapper {
  flex-direction: column;
  height: 100%;
}

.content {
  flex-grow: 2;
  height: 100%;

  .grid {
    height: 100%;

    #metadata-header {
      margin-top: calc(var(--spacer) * 2.5);
      position: relative;

      #assign-tags-button {
        margin-left: calc(var(--spacer) * 2.5);
      }

      #download_metadata {
        margin: 0;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        right: 0;
      }
    }

    .grid-view {
      min-height: 100%;
      align-items: stretch;
    }
  }
}

gz-image-repo {
  padding: calc(var(--spacer) * 10);
}

gz-grid-view {
  padding-top: calc(var(--spacer) * 2);
}
